'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDatetime = require('react-datetime');

var _reactDatetime2 = _interopRequireDefault(_reactDatetime);

var _DateTimeInputWidget2 = require('react-jsonschema-form/lib/components/widgets/DateTimeInputWidget');

var _DateTimeInputWidget3 = _interopRequireDefault(_DateTimeInputWidget2);

var _utils = require('react-jsonschema-form/lib/utils');

var _reactInputMask = require('react-input-mask');

var _reactInputMask2 = _interopRequireDefault(_reactInputMask);

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

require('moment/locale/ru');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */

var validateDates = function validateDates(availableDates) {
  return function (current) {
    if (availableDates === 'future') {
      var yesterday = _reactDatetime2.default.moment().subtract(1, 'day');
      return current.isAfter(yesterday);
    }
    if (availableDates === 'past') {
      return (0, _moment2.default)(current).isBefore();
    }
    return true;
  };
};

var getDefaultPlaceHolder = function getDefaultPlaceHolder(dateTimeWidgetType) {
  var defaultPlaceholder = null;
  var mask = null;
  var format = null;

  if (!dateTimeWidgetType || dateTimeWidgetType === 'dateTime') {
    defaultPlaceholder = _i18next2.default.t('placeholders:widget.dateTime', {}); //'ДД.ММ.ГГГГ чч:мм'
    mask = 'dD.mM.y999 12:39';
    format = 'DD.MM.YYYY HH:mm';
  } else if (dateTimeWidgetType === 'date') {
    defaultPlaceholder = _i18next2.default.t('placeholders:widget.dateOnly', {}); //'ДД.ММ.ГГГГ'
    mask = 'dD.mM.y999';
    format = 'DD.MM.YYYY';
  } else if (dateTimeWidgetType === 'time') {
    defaultPlaceholder = _i18next2.default.t('placeholders:widget.timeOnly', {}); //'ЧЧ:ММ'
    mask = '12:39';
    format = 'HH:mm';
  }

  return {
    defaultPlaceholder: defaultPlaceholder,
    mask: mask,
    format: format
  };
};

var OverridedDateTimeInputWidget = function (_DateTimeInputWidget) {
  (0, _inherits3.default)(OverridedDateTimeInputWidget, _DateTimeInputWidget);

  function OverridedDateTimeInputWidget(props) {
    (0, _classCallCheck3.default)(this, OverridedDateTimeInputWidget);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OverridedDateTimeInputWidget.__proto__ || (0, _getPrototypeOf2.default)(OverridedDateTimeInputWidget)).call(this, props));

    _this.renderInput = function (props, openCalendar) {
      var _this$props = _this.props,
          id = _this$props.id,
          value = _this$props.value,
          _onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          placeholder = _this$props.placeholder,
          dateTimeWidgetType = _this$props.options.dateTimeWidgetType,
          formContext = _this$props.formContext;

      var _ref = value ? value.split(' ') : [],
          _ref2 = (0, _slicedToArray3.default)(_ref, 2),
          _ref2$ = _ref2[0],
          date = _ref2$ === undefined ? '' : _ref2$,
          _ref2$2 = _ref2[1],
          time = _ref2$2 === undefined ? '' : _ref2$2;

      var _ref3 = date ? date.split('.') : [],
          _ref4 = (0, _slicedToArray3.default)(_ref3, 3),
          _ref4$ = _ref4[0],
          day = _ref4$ === undefined ? '' : _ref4$,
          _ref4$2 = _ref4[1],
          month = _ref4$2 === undefined ? '' : _ref4$2,
          _ref4$3 = _ref4[2],
          year = _ref4$3 === undefined ? '' : _ref4$3;

      var D = void 0;
      var format = void 0;
      if (day.startsWith('3')) {
        D = '[01]';
      } else if (day.startsWith('0')) {
        D = '[1-9]';
      } else {
        D = '[0-9]';
      }

      var M = void 0;
      if (month.startsWith('1')) {
        M = '[0-2]';
      } else if (month.startsWith('0')) {
        M = '[1-9]';
      } else {
        M = '[0-9]';
      }

      var defaultPlaceholderData = getDefaultPlaceHolder(dateTimeWidgetType);

      var defaultPlaceholder = defaultPlaceholderData.defaultPlaceholder;
      var mask = defaultPlaceholderData.mask;
      format = defaultPlaceholderData.format;

      /*if (!dateTimeWidgetType || dateTimeWidgetType === 'dateTime') {
        defaultPlaceholder =  i18next.t(`placeholders:widget.dateTime`, {}) //'ДД.ММ.ГГГГ чч:мм'
        mask = 'dD.mM.y999 12:39'
        format = 'DD.MM.YYYY HH:mm'
      } else if (dateTimeWidgetT__.__.____ __:__ype === 'date') {
        defaultPlaceholder = i18next.t(`placeholders:widget.dateOnly`, {}) //'ДД.ММ.ГГГГ'
        mask = 'dD.mM.y999'
        format = 'DD.MM.YYYY'
      } else if (dateTimeWidgetType === 'time') {
        defaultPlaceholder = i18next.t(`placeholders:widget.timeOnly`, {}) //'ЧЧ:ММ'
        mask = '12:39'
        format = 'HH:mm'
      }*/

      var cssPrefix = formContext.cssPrefix;

      return _react2.default.createElement(_reactInputMask2.default, {
        mask: mask,
        maskChar: '_',
        placeholder: placeholder || defaultPlaceholder,
        className: formContext && formContext.preview ? 'ant-input ant-input-lg' : cssPrefix + '__form-control',
        onChange: function onChange(event) {
          _onChange(event.target.value);
        },
        onBlur: onBlur && function (_ref5) {
          var value = _ref5.target.value;

          if (/\d/.test(value)) {
            formContext.setDirty(id);
            _onChange(value);
          } else {
            _onChange(undefined);
          }
        },
        onFocus: function onFocus(a) {
          formContext.setTouched(id);
        },
        onClick: openCalendar,
        value: value || '',
        formatChars: {
          '9': '[0-9]',
          'd': '[0-3]',
          'D': D,
          'm': '[01]',
          'M': M,
          'y': '[12]',
          '1': '[0-2]',
          '2': time.startsWith('2') ? '[0-3]' : '[0-9]',
          '3': '[0-5]'
        }
      });
    };

    var i18nInstance = props.formContext.i18nInstance;

    var locale = 'ru';
    if (i18nInstance) {
      locale = i18nInstance.language;
    }
    _this.state = {
      locale: locale,
      calendarIsOpened: false
    };
    return _this;
  }

  (0, _createClass3.default)(OverridedDateTimeInputWidget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          value = _props.value,
          readonly = _props.readonly,
          autofocus = _props.autofocus,
          _onChange2 = _props.onChange,
          onBlur = _props.onBlur,
          options = _props.options,
          schema = _props.schema,
          formContext = _props.formContext,
          registry = _props.registry,
          inputProps = (0, _objectWithoutProperties3.default)(_props, ['id', 'value', 'readonly', 'autofocus', 'onChange', 'onBlur', 'options', 'schema', 'formContext', 'registry']);

      //  console.log('value', value , 'is date valid:', moment(value, dateTimeFormat, true).isValid(), 'js format', new Date(value))

      var dateTimeWidgetType = options.dateTimeWidgetType,
          dateTimeAvailableDates = options.dateTimeAvailableDates;

      var dateFormat = false,
          timeFormat = false,
          format = void 0,
          viewMode = 'days';
      if (!dateTimeWidgetType || dateTimeWidgetType === 'dateTime') {
        dateFormat = 'DD.MM.YYYY';
        timeFormat = 'HH:mm';
        format = 'DD.MM.YYYY HH:mm';
      } else if (dateTimeWidgetType === 'date') {
        dateFormat = 'DD.MM.YYYY';
        format = 'DD.MM.YYYY';
      } else if (dateTimeWidgetType === 'time') {
        timeFormat = 'HH:mm';
        format = 'HH:mm';
        viewMode = 'time';
      }
      var cssPrefix = formContext.cssPrefix;
      var locale = this.state.locale;

      return _react2.default.createElement(_reactDatetime2.default, {
        locale: locale,
        name: id,
        className: cssPrefix + '__date-time-picker ' + id + '__picker',
        dateFormat: dateFormat,
        timeFormat: timeFormat,
        value: value,
        viewMode: viewMode,
        timeConstraints: {
          minutes: {
            step: 5
          }
        },
        isValidDate: validateDates(dateTimeAvailableDates),
        onBlur: onBlur && function (value) {
          if (/\d/.test(value)) {
            formContext.setDirty(id);
            _onChange2((0, _utils.formatDateCustom)(format)(value));
          } else {
            _onChange2(undefined);
          }
        },
        onChange: function onChange(value) {
          _onChange2((0, _utils.formatDateCustom)(format)(value));
        },
        renderInput: this.renderInput,
        onFocus: function onFocus() {
          formContext.setTouched(id);
        }
      });
    }
  }]);
  return OverridedDateTimeInputWidget;
}(_DateTimeInputWidget3.default);

exports.default = OverridedDateTimeInputWidget;


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/components/Overrided/widgets/DateTimeInputWidget.js
// module id = 1118
// module chunks = 5